require('./assets/style/iconfont.css');


import Vue from 'vue'
import FastClick from 'fastclick'
import VueWechatTitle from 'vue-wechat-title'
import VueAnalytics from 'vue-analytics';
import router from './router'
import store from './store'



import App from './App'





import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)


import api from './api/index.js'

Vue.prototype.$http = api

Vue.use(VueWechatTitle)


Vue.use(VueAnalytics, {
id: process.env.VUE_APP_UA_ID,
router 
});


FastClick.attach(document.body)

Vue.config.productionTip = false


const windowHeight = window.innerHeight
Vue.directive('fixedInput', function(el, binding) {
el.addEventListener('blur', function() {
if (!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
return
}
let windowFocusHeight = window.innerHeight
if (windowHeight == windowFocusHeight) {
return
}
let currentPosition;
let speed = 1; 
currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
currentPosition -= speed;
window.scrollTo(0, currentPosition); 
currentPosition += speed; 
window.scrollTo(0, currentPosition); 
})
})

/* eslint-disable no-new */
window.vm = new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js